export interface AuthState {
  errorMessage: string | null;
  responseType: string | null;
}

export const initialState: AuthState = {
  errorMessage: null,
  responseType: null,
};
